import { render, staticRenderFns } from "./NewClearSaveButtons.vue?vue&type=template&id=72c7b5d7&scoped=true"
import script from "./NewClearSaveButtons.vue?vue&type=script&lang=ts"
export * from "./NewClearSaveButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c7b5d7",
  null
  
)

export default component.exports